export interface ComicChapter {
  num: number;
  title: string;
  updateTime: string;
}

export interface Comic {
  id: string;
  title: string;
  category: string;
  status: "连载中" | "已完结";
  latestChapter: number;
  totalChapters: number;
  updateTime: string;
  cover: string;
  description: string;
  tags: string[];
  views: number;
  rating: number;
  weekRank?: number;
  chapters: ComicChapter[];
}

export const categories: string[] = [
  "热血冒险",
  "奇幻异世界",
  "恋爱校园",
  "悬疑惊悚",
  "科幻机甲",
  "古风武侠",
  "运动竞技",
  "日常治愈",
];

export const comics: Comic[] = [
  {
    id: "poxiaocangqiong",
    title: "破晓苍穹",
    category: "热血冒险",
    status: "连载中",
    latestChapter: 238,
    totalChapters: 238,
    updateTime: "今日 10:20",
    cover: "https://readdy.ai/api/search-image?query=manga%20comic%20cover%20illustration%2C%20heroic%20young%20swordsman%20standing%20against%20a%20giant%20celestial%20dragon%20at%20sunrise%2C%20coral%20and%20gold%20sky%2C%20bold%20ink%20outlines%2C%20dynamic%20action%20pose%2C%20vibrant%20storybook%20energy%2C%20clean%20composition&width=400&height=560&seq=cover-01&orientation=portrait",
    description:
      "少年陈烈在破晓时分觉醒苍穹之力，踏上与天相争的冒险之旅。这部热血冒险漫坚持周更两话，最新话已更新到第238话，主角正在苍龙城与守城大将正面交锋，追更进度稳步推进。",
    tags: ["热血", "冒险", "少年", "东方玄幻"],
    views: 892000,
    rating: 4.8,
    weekRank: 1,
    chapters: [
      { num: 238, title: "破晓之名", updateTime: "今日 10:20" },
      { num: 237, title: "苍龙城的决战", updateTime: "昨日" },
      { num: 236, title: "苍穹之力的代价", updateTime: "3天前" },
      { num: 235, title: "夜探观星台", updateTime: "4天前" },
      { num: 234, title: "烈阳诀·初成", updateTime: "上周" },
    ],
  },
  {
    id: "xinghailvren",
    title: "星海旅人",
    category: "科幻机甲",
    status: "连载中",
    latestChapter: 152,
    totalChapters: 152,
    updateTime: "今日 08:45",
    cover: "https://readdy.ai/api/search-image?query=manga%20comic%20cover%20illustration%2C%20mecha%20pilot%20in%20sleek%20silver%20armor%20floating%20in%20a%20vast%20star%20nebula%2C%20teal%20and%20coral%20glow%20from%20engine%20lights%2C%20bold%20sci-fi%20ink%20lines%2C%20dynamic%20and%20cinematic%2C%20clean%20composition&width=400&height=560&seq=cover-02&orientation=portrait",
    description:
      "在无垠星海间流浪的机甲旅人，追寻失落家园的坐标。这部科幻机甲漫更新到第152话，最新话揭开了旅人起源的真相，人气与口碑持续走高。",
    tags: ["科幻", "机甲", "太空", "冒险"],
    views: 746000,
    rating: 4.7,
    weekRank: 2,
    chapters: [
      { num: 152, title: "归乡坐标", updateTime: "今日 08:45" },
      { num: 151, title: "星环追逐战", updateTime: "昨日" },
      { num: 150, title: "旅人的真相", updateTime: "3天前" },
    ],
  },
  {
    id: "linghuyueyan",
    title: "灵狐月宴",
    category: "奇幻异世界",
    status: "连载中",
    latestChapter: 89,
    totalChapters: 89,
    updateTime: "今日 09:10",
    cover: "https://readdy.ai/api/search-image?query=manga%20comic%20cover%20illustration%2C%20nine-tailed%20spirit%20fox%20girl%20in%20a%20moonlit%20forest%20banquet%2C%20soft%20amber%20moonlight%2C%20magical%20fireflies%2C%20elegant%20fantasy%20linework%2C%20warm%20and%20dreamy%2C%20clean%20composition&width=400&height=560&seq=cover-03&orientation=portrait",
    description:
      "月圆之夜，九尾灵狐设宴人间，与误入的凡人少年结下不解之缘。这部奇幻异世界漫更新到第89话，最新章节在月宴上展开一场温柔的较量。",
    tags: ["奇幻", "治愈", "异世界", "妖怪"],
    views: 615000,
    rating: 4.6,
    weekRank: 3,
    chapters: [
      { num: 89, title: "月宴的约定", updateTime: "今日 09:10" },
      { num: 88, title: "灵狐的旧梦", updateTime: "昨日" },
      { num: 87, title: "灯火阑珊处", updateTime: "2天前" },
    ],
  },
  {
    id: "xiaoyuanlianqu77",
    title: "校园恋曲77",
    category: "恋爱校园",
    status: "连载中",
    latestChapter: 210,
    totalChapters: 210,
    updateTime: "今日 12:00",
    cover: "https://readdy.ai/api/search-image?query=manga%20comic%20cover%20illustration%2C%20two%20school%20students%20under%20a%20blossoming%20cherry%20tree%20on%20campus%2C%20soft%20warm%20pastel%20tones%2C%20romantic%20atmosphere%2C%20light%20linework%2C%20clean%20and%20charming%20composition&width=400&height=560&seq=cover-04&orientation=portrait",
    description:
      "高二年级的日常，藏着第77种心动。这部恋爱校园漫更新到第210话，男女主角的关系终于迎来关键转折，最新话甜度爆表。",
    tags: ["恋爱", "校园", "日常", "青春"],
    views: 968000,
    rating: 4.9,
    weekRank: 4,
    chapters: [
      { num: 210, title: "第77种心动", updateTime: "今日 12:00" },
      { num: 209, title: "告白的前夜", updateTime: "昨日" },
      { num: 208, title: "樱花树下的约定", updateTime: "3天前" },
    ],
  },
  {
    id: "muwudanganju",
    title: "迷雾档案局",
    category: "悬疑惊悚",
    status: "连载中",
    latestChapter: 66,
    totalChapters: 66,
    updateTime: "今日 07:30",
    cover: "https://readdy.ai/api/search-image?query=manga%20comic%20cover%20illustration%2C%20detective%20in%20a%20noir%20foggy%20city%20bureau%20holding%20mysterious%20case%20files%2C%20deep%20shadows%20with%20warm%20amber%20highlights%2C%20suspenseful%20mood%2C%20bold%20manga%20lines%2C%20clean%20composition&width=400&height=560&seq=cover-05&orientation=portrait",
    description:
      "一桩无法结案的悬案，牵出一座城市的黑暗。这部悬疑惊悚漫更新到第66话，档案局特工逐渐逼近真相，每话都留下新的谜团。",
    tags: ["悬疑", "惊悚", "推理", "都市"],
    views: 423000,
    rating: 4.5,
    weekRank: 6,
    chapters: [
      { num: 66, title: "第66号档案", updateTime: "今日 07:30" },
      { num: 65, title: "消失的证人", updateTime: "昨日" },
      { num: 64, title: "迷雾中的线索", updateTime: "4天前" },
    ],
  },
  {
    id: "jianqichangan",
    title: "剑起长安",
    category: "古风武侠",
    status: "已完结",
    latestChapter: 120,
    totalChapters: 120,
    updateTime: "2026-08-01",
    cover: "https://readdy.ai/api/search-image?query=manga%20comic%20cover%20illustration%2C%20ancient%20chinese%20swordsman%20standing%20on%20a%20chang-an%20rooftop%20at%20dusk%2C%20ink%20wash%20style%20with%20red%20banners%2C%20wuxia%20atmosphere%2C%20dramatic%20lighting%2C%20bold%20linework%2C%20clean%20composition&width=400&height=560&seq=cover-06&orientation=portrait",
    description:
      "乱世长安，一剑风云起。这部古风武侠漫已全120话完结，从长安城头到江湖远岸，完整讲述了剑客沈青的一生。适合一口气追完。",
    tags: ["武侠", "古风", "完结", "权谋"],
    views: 1102000,
    rating: 4.9,
    weekRank: 5,
    chapters: [
      { num: 120, title: "长安月（大结局）", updateTime: "2026-08-01" },
      { num: 119, title: "天下棋局", updateTime: "2026-07-29" },
      { num: 118, title: "剑出鞘", updateTime: "2026-07-27" },
    ],
  },
  {
    id: "huofenienpanlu",
    title: "火凤涅槃录",
    category: "古风武侠",
    status: "连载中",
    latestChapter: 178,
    totalChapters: 178,
    updateTime: "今日 11:15",
    cover: "https://readdy.ai/api/search-image?query=manga%20comic%20cover%20illustration%2C%20phoenix%20reborn%20rising%20from%20golden%20flames%20above%20a%20wuxia%20clan%2C%20red%20and%20gold%20palette%2C%20epic%20fantasy%20wuxia%2C%20bold%20ink%20and%20color%2C%20dramatic%20composition&width=400&height=560&seq=cover-07&orientation=portrait",
    description:
      "浴火重生，凤鸣九霄。这部古风武侠漫更新到第178话，女主火凤之力完全觉醒，最新话与宿敌正面交锋，打斗场面张力十足。",
    tags: ["武侠", "玄幻", "女主", "重生"],
    views: 689000,
    rating: 4.7,
    chapters: [
      { num: 178, title: "凤鸣九霄", updateTime: "今日 11:15" },
      { num: 177, title: "浴火之战", updateTime: "昨日" },
      { num: 176, title: "觉醒的前奏", updateTime: "2天前" },
    ],
  },
  {
    id: "jixiejiyuan",
    title: "机械纪元",
    category: "科幻机甲",
    status: "已完结",
    latestChapter: 96,
    totalChapters: 96,
    updateTime: "2026-07-20",
    cover: "https://readdy.ai/api/search-image?query=manga%20comic%20cover%20illustration%2C%20post-apocalyptic%20mech%20battle%20in%20a%20ruined%20city%2C%20steel%20and%20orange%20sparks%2C%20gritty%20mecha%20style%2C%20bold%20sci-fi%20lines%2C%20dramatic%20lighting%2C%20clean%20composition&width=400&height=560&seq=cover-08&orientation=portrait",
    description:
      "人类文明陨落后，机械觉醒的时代降临。这部科幻机甲漫已全96话完结，从废弃都市到最后的反抗，科幻与热血兼备。",
    tags: ["科幻", "机甲", "末日", "完结"],
    views: 774000,
    rating: 4.6,
    chapters: [
      { num: 96, title: "新纪元（大结局）", updateTime: "2026-07-20" },
      { num: 95, title: "最后的引擎", updateTime: "2026-07-18" },
      { num: 94, title: "钢铁之心", updateTime: "2026-07-16" },
    ],
  },
  {
    id: "shenyeshitangwu",
    title: "深夜食堂屋",
    category: "日常治愈",
    status: "连载中",
    latestChapter: 300,
    totalChapters: 300,
    updateTime: "今日 06:50",
    cover: "https://readdy.ai/api/search-image?query=manga%20comic%20cover%20illustration%2C%20cozy%20night%20diner%20with%20a%20chef%20at%20a%20warm%20wooden%20counter%2C%20steam%20and%20soft%20lamp%20glow%2C%20healing%20and%20gentle%20mood%2C%20warm%20toned%20linework%2C%20clean%20composition&width=400&height=560&seq=cover-09&orientation=portrait",
    description:
      "深夜零点营业的小食堂，用一餐饭治愈都市人的疲惫。这部日常治愈漫已更新到第300话，每一话都是一个温暖的小故事。",
    tags: ["日常", "治愈", "美食", "暖心"],
    views: 531000,
    rating: 4.8,
    chapters: [
      { num: 300, title: "第三百夜的粥", updateTime: "今日 06:50" },
      { num: 299, title: "雨夜的关东煮", updateTime: "昨日" },
      { num: 298, title: "一碗姜汤", updateTime: "2天前" },
    ],
  },
  {
    id: "anhemodaoshu",
    title: "暗黑魔导书",
    category: "奇幻异世界",
    status: "已完结",
    latestChapter: 140,
    totalChapters: 140,
    updateTime: "2026-06-30",
    cover: "https://readdy.ai/api/search-image?query=manga%20comic%20cover%20illustration%2C%20dark%20sorcerer%20holding%20a%20glowing%20forbidden%20grimoire%2C%20violet%20and%20gold%20arcane%20energy%2C%20gothic%20fantasy%20style%2C%20mysterious%20and%20epic%2C%20bold%20lines%2C%20clean%20composition&width=400&height=560&seq=cover-10&orientation=portrait",
    description:
      "翻开禁忌之书，召唤被封印的暗影。这部奇幻异世界漫已全140话完结，从学徒到魔导至尊，魔法与人性交织的完整长篇。",
    tags: ["魔法", "异世界", "暗黑", "完结"],
    views: 602000,
    rating: 4.5,
    chapters: [
      { num: 140, title: "封印的终结（大结局）", updateTime: "2026-06-30" },
      { num: 139, title: "暗影之王", updateTime: "2026-06-28" },
      { num: 138, title: "禁忌之书", updateTime: "2026-06-26" },
    ],
  },
  {
    id: "lanqiugianfengxian",
    title: "篮球前锋线",
    category: "运动竞技",
    status: "连载中",
    latestChapter: 233,
    totalChapters: 233,
    updateTime: "今日 13:40",
    cover: "https://readdy.ai/api/search-image?query=manga%20comic%20cover%20illustration%2C%20basketball%20player%20mid-dunk%20in%20a%20packed%20gymnasium%2C%20dynamic%20motion%2C%20sweat%20and%20energy%2C%20orange%20and%20teal%20accents%2C%20bold%20sports%20manga%20lines%2C%20clean%20composition&width=400&height=560&seq=cover-11&orientation=portrait",
    description:
      "从替补席到全国赛场的逆袭之路。这部运动竞技漫更新到第233话，最新话是分区决赛的决胜时刻，热血燃到极致。",
    tags: ["运动", "篮球", "热血", "青春"],
    views: 855000,
    rating: 4.8,
    weekRank: 7,
    chapters: [
      { num: 233, title: "决胜加时", updateTime: "今日 13:40" },
      { num: 232, title: "最后一攻", updateTime: "昨日" },
      { num: 231, title: "板凳奇兵", updateTime: "3天前" },
    ],
  },
  {
    id: "dushiyinenglieren",
    title: "都市异能猎人",
    category: "悬疑惊悚",
    status: "连载中",
    latestChapter: 145,
    totalChapters: 145,
    updateTime: "今日 15:05",
    cover: "https://readdy.ai/api/search-image?query=manga%20comic%20cover%20illustration%2C%20urban%20hero%20with%20glowing%20supernatural%20power%20on%20a%20night%20city%20street%2C%20neon%20and%20warm%20lights%2C%20suspenseful%20modern%20fantasy%2C%20bold%20lines%2C%20dynamic%20pose%2C%20clean%20composition&width=400&height=560&seq=cover-12&orientation=portrait",
    description:
      "暗夜都市里，异能力者与神秘组织周旋。这部都市异能漫更新到第145话，最新话主角的能力迎来进化，主线谜团逐渐清晰。",
    tags: ["都市", "异能", "悬疑", "战斗"],
    views: 509000,
    rating: 4.4,
    chapters: [
      { num: 145, title: "能力进化", updateTime: "今日 15:05" },
      { num: 144, title: "暗夜对峙", updateTime: "昨日" },
      { num: 143, title: "组织的真相", updateTime: "2天前" },
    ],
  },
];

export interface TodayUpdate {
  comicId: string;
  chapterNum: number;
  chapterTitle: string;
  time: string;
}

export const todayUpdates: TodayUpdate[] = [
  { comicId: "poxiaocangqiong", chapterNum: 238, chapterTitle: "破晓之名", time: "10:20" },
  { comicId: "xinghailvren", chapterNum: 152, chapterTitle: "归乡坐标", time: "08:45" },
  { comicId: "linghuyueyan", chapterNum: 89, chapterTitle: "月宴的约定", time: "09:10" },
  { comicId: "xiaoyuanlianqu77", chapterNum: 210, chapterTitle: "第77种心动", time: "12:00" },
  { comicId: "muwudanganju", chapterNum: 66, chapterTitle: "第66号档案", time: "07:30" },
  { comicId: "huofenienpanlu", chapterNum: 178, chapterTitle: "凤鸣九霄", time: "11:15" },
  { comicId: "shenyeshitangwu", chapterNum: 300, chapterTitle: "第三百夜的粥", time: "06:50" },
  { comicId: "lanqiugianfengxian", chapterNum: 233, chapterTitle: "决胜加时", time: "13:40" },
  { comicId: "dushiyinenglieren", chapterNum: 145, chapterTitle: "能力进化", time: "15:05" },
];

export const faqItems = [
  {
    q: "无尽漫画网多久更新一次追更信息？",
    a: "我们会实时整理并滚动刷新各作品的更新状态。连载中作品每有新话上线即会更新到最新话与更新时间，页面顶部「今日更新」板块会集中展示当天更新的作品与话数。",
  },
  {
    q: "如何在无尽漫画网查询我追的漫画更新到第几话了？",
    a: "进入漫画列表页后，可按「连载中」或「已完结」状态筛选，也可按分类筛选；每张漫画卡片上都清晰标注最新章节话数与最近更新时间，方便你快速定位自己追的每一部作品。",
  },
  {
    q: "连载中与已完结的作品有什么区别？",
    a: "连载中作品会持续更新，页面会展示最新话数与更新时间，方便你追踪追更进度；已完结作品则展示总话数，标注「全N话」，适合一口气从头追到尾。",
  },
  {
    q: "为什么有的漫画今天没有显示更新？",
    a: "不同作品有各自的更新节奏，有的日更、有的周更，也有休刊期。如果某部作品当日没有新话，「今日更新」板块就不会出现它；你可以点进详情页查看它最近的一次更新记录。",
  },
  {
    q: "收藏的追更进度会保存多久？",
    a: "当前阶段追更进度为站内浏览展示。后续接入账号系统后，登录用户可长期保存收藏列表与追更进度，方便随时回来继续追。",
  },
  {
    q: "如何反馈漏更或错误的信息？",
    a: "如果你发现某部作品的最新话数或状态有误，可以通过页面底部的联系方式或「关于我们」中的联系邮箱反馈给我们，我们会尽快核实修正。",
  },
];

export function getComicById(id: string): Comic | undefined {
  return comics.find((c) => c.id === id);
}